import type { FormContextType } from "#root/components/form";

export const Valid = 0;
export const Invalid = 1;
export const Neutral = 2;

export type Validity = typeof Valid | typeof Invalid | typeof Neutral;

export interface ValidationResult {
  validity: Validity;
  hint: string;
}

export type Validator<T = string> = (value: T) => ValidationResult | undefined;

export function regex(expr: RegExp, hint: string): Validator {
  return (value: string): ValidationResult | undefined => {
    if (!expr.test(value)) {
      return { validity: Invalid, hint };
    }
  };
}

export function json(value: string): ValidationResult | undefined {
  try {
    JSON.parse(value);
  } catch {
    return { validity: Invalid, hint: "Invalid JSON" };
  }
}

export function required(value: string): ValidationResult | undefined {
  if (value.length === 0) {
    return { validity: Invalid, hint: "Required" };
  }
}

export function name(value: string): ValidationResult | undefined {
  if (value.length < 3) {
    return { validity: Invalid, hint: "Invalid Name" };
  }
}

export function company(value: string): ValidationResult | undefined {
  if (value.length < 3) {
    return { validity: Invalid, hint: "Invalid Company Name" };
  }
}

export function productName(value: string): ValidationResult | undefined {
  if (value.length < 3) {
    return { validity: Invalid, hint: "Invalid Product Name" };
  }
}

export function categoryName(value: string): ValidationResult | undefined {
  if (value.length < 3) {
    return { validity: Invalid, hint: "Invalid Category Name" };
  }
}

export function domain(value: string): ValidationResult | undefined {
  if (value.length === 0) {
    return { validity: Invalid, hint: "Invalid Domain" };
  }
}

export const uri: Validator = regex(/^https?:\/\/./, "Invalid URI");
export const taxId: Validator = regex(/^\d{3}-\d{2}-\d{4}$/, "Invalid Tax ID");
export const email: Validator = regex(/\S+@\S+\.\S+/, "Invalid Email Address");

export function password(value: string): ValidationResult | undefined {
  if (value.length < 7) {
    return { validity: Invalid, hint: "Invalid Password" };
  }
}

export function passwordConfirm(siblingName: string, form: FormContextType | undefined): Validator {
  return value => {
    const sibling = form?.field(siblingName);
    if (sibling?.value !== value) {
      return { validity: Invalid, hint: "Password does not match" };
    }

    return password(value);
  };
}
